import { render, staticRenderFns } from "./AppPageHeader.vue?vue&type=template&id=49b1ad55&scoped=true"
import script from "./AppPageHeader.vue?vue&type=script&lang=ts"
export * from "./AppPageHeader.vue?vue&type=script&lang=ts"
import style0 from "./AppPageHeader.vue?vue&type=style&index=0&id=49b1ad55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1ad55",
  null
  
)

export default component.exports